/**
 * Režim tisku mapové vrstvy.
 */
export enum LayerPrintMode {
    /**
     * Tisk vrstev je zakázán.
     */
    DISABLED = 'DISABLED',

    /**
     * Tisknout se budou aktuálně viditelné vrstvy.
     */
    VISIBLE = 'VISIBLE',

    /**
     * Tisknout se budou vrstvy nastavené v aktuálním v téma konfigurace.
     */
    TOPIC = 'TOPIC',
}
